import useApiUrl from '../../framework/hooks/useApiUrlHook';

export default function TeamItem({ teamMember, active }) {
    const apiUrl = useApiUrl();

    var voln = teamMember.volledigenaam;
    var vn = voln.substring(0, voln.indexOf(' '));
    var an = voln.substring(voln.indexOf(' ') + 1);

    return (
        <a href={`medemerkers/${teamMember.url}`} className={`team-wrap ${active ? 'active' : ''}`}>
            <div className="thumb" style={{ backgroundImage: `url(${apiUrl}/img/extern/ratio/www.bandwerk.nl/medewerkers/orig/1000/1400/100/${teamMember.image})` }}>

            </div>
            <div className="signe"> {teamMember.functie} </div>
            <div className="title-1">{vn} <br/> {an}</div>
            <div className="title-2"> {teamMember.voornaam} </div>
        </a>
    );
}
